import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Form from './Form';

export default function SendMailModal({ enterpriseId, link, onHide }) {
  return (
    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Slack Integration Setup
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onHide={onHide} enterpriseId={enterpriseId} link={link} />
      </Modal.Body>
    </Modal>
  );
}

SendMailModal.propTypes = {
  link: PropTypes.string.isRequired,
  enterpriseId: PropTypes.number.isRequired,
  onHide: PropTypes.func.isRequired,
};
